import { FC } from 'react'

import clsx from 'clsx'

import { AppIcon } from '../app-icon'
import { AllIcons } from '../app-icon/types'
import { RadioButton } from '../radio-button'

import s from './styles.module.scss'

interface Props {
  icon: AllIcons
  title?: string
  subTitle?: string
  description?: string
  isActive?: boolean
  isDisabled?: boolean
  onClick?: () => void
}

export const PaymentType: FC<Props> = ({
  icon,
  title,
  subTitle,
  isActive,
  onClick,
}) => {
  return (
    <div
      className={clsx(s.container, isActive && s.containerActive)}
      onClick={onClick}
    >
      <div className={s.header}>
        <div className={clsx(s.icon, isActive && s.green)}>
          <AppIcon
            height={24}
            id={icon}
            width={24}
          />
        </div>

        <RadioButton isActive={isActive} />
      </div>

      <div className={s.names}>
        {title && <p className={clsx(s.title, 'bold-14')}>{title}</p>}
        {subTitle && (
          <p className={clsx(s.subTitle, 'regular-12')}>{subTitle}</p>
        )}
      </div>
    </div>
  )
}
